"use client";

import React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Calltoaction() {
  return <section id="calltoaction" className="w-full py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl text-center">
        <h2 className="text-2xl md:text-3xl font-default font-semibold text-primary-heading mb-4">
          まずはお気軽にご相談ください
        </h2>
        <p className="text-foreground/80 text-base md:text-lg mb-10 leading-relaxed">
          初めての方も、話したいことがまとまっていなくても大丈夫です。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button asChild size="lg" className="w-full sm:w-auto px-8 shadow-md rounded-lg">
            <Link to="https://yotsuya-sc-room.com/reserve/">
              ご予約・お問い合わせフォーム
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto px-8 border-primary text-primary-heading hover:bg-primary/10 rounded-lg">
            <Link to="tel:080-9553-8244">
              <Phone className="mr-2 size-4" />
              080-9553-8244
            </Link>
          </Button>
        </div>
        <p className="mt-8 text-sm text-muted-foreground">
          開室時間 10:00〜21:00
        </p>
      </div>
    </section>;
}